/* eslint-disable no-console */
export const state = () => ({
  monthlyRedirectLoading: false,
  monthlyRedirectSuccess: '',
  monthlyRedirectError: '',

  convertMonthlyQuoteToPolicyLoading: false,
  convertMonthlyQuoteToPolicySuccess: '',
  convertMonthlyQuoteToPolicyError: '',
})

export const getters = {
  monthlyRedirectLoading(state) {
    return state.monthlyRedirectLoading
  },
  monthlyRedirectSuccess(state) {
    return state.monthlyRedirectSuccess
  },
  monthlyRedirectError(state) {
    return state.monthlyRedirectError
  },

  convertMonthlyQuoteToPolicyLoading(state) {
    return state.convertMonthlyQuoteToPolicyLoading
  },
  convertMonthlyQuoteToPolicySuccess(state) {
    return state.convertMonthlyQuoteToPolicySuccess
  },
  convertMonthlyQuoteToPolicyError(state) {
    return state.convertMonthlyQuoteToPolicyError
  },
}

export const mutations = {
  SET_MONTHLY_REDIRECT_LOADING: (state, isLoading) => {
    state.monthlyRedirectLoading = isLoading
  },
  SET_MONTHLY_REDIRECT_SUCCESS: (state, success) => {
    state.monthlyRedirectSuccess = success
  },
  SET_MONTHLY_REDIRECT_ERROR: (state, error) => {
    state.monthlyRedirectError = error
  },

  SET_CONVERT_MONTHLY_QUOTE_TO_POLICY_LOADING: (state, isLoading) => {
    state.convertMonthlyQuoteToPolicyLoading = isLoading
  },
  SET_CONVERT_MONTHLY_QUOTE_TO_POLICY_SUCCESS: (state, success) => {
    state.convertMonthlyQuoteToPolicySuccess = success
  },
  SET_CONVERT_MONTHLY_QUOTE_TO_POLICY_ERROR: (state, error) => {
    state.convertMonthlyQuoteToPolicyError = error
  },
}

export const actions = {
  async monthlyRedirect({ commit }, { quoteId }) {
    commit('SET_MONTHLY_REDIRECT_LOADING', true)
    try {
      const data = await this.$axios.$post(
        `/api/policy/v1/pay/${quoteId}/monthly/gocardless`
      )

      console.log('SET_MONTHLY_REDIRECT_SUCCESS', data)
      commit('SET_MONTHLY_REDIRECT_SUCCESS', data)
      commit('SET_MONTHLY_REDIRECT_ERROR', '')
      window.location.href = data.redirect_url
    } catch (error) {
      console.log('SET_MONTHLY_REDIRECT_ERROR', error)
      commit('SET_MONTHLY_REDIRECT_SUCCESS', '')
      commit('SET_MONTHLY_REDIRECT_ERROR', error)
      this.$toast.error('Error while generating GoCardless redirect URL')
    }
    commit('SET_MONTHLY_REDIRECT_LOADING', false)
  },

  async convertMonthlyQuoteToPolicy(
    { commit },
    { code, redirectFlowId, type }
  ) {
    commit('SET_CONVERT_MONTHLY_QUOTE_TO_POLICY_LOADING', true)
    try {
      const data = await this.$axios.$post(
        `/api/payment/v1/gocardless/success`,
        { code, redirectFlowId }
      )
      console.log('SET_CONVERT_MONTHLY_QUOTE_TO_POLICY_SUCCESS', data)
      commit('SET_CONVERT_MONTHLY_QUOTE_TO_POLICY_SUCCESS', data)
      commit('SET_CONVERT_MONTHLY_QUOTE_TO_POLICY_ERROR', '')

      // Track only new buessness
      if (type === 'default') {
        this.$gtm.push({
          event: 'purchase_complete',
          payment_type: 'Go Cardless',
          transactionId: data.policy_code || '',
          transactionTotal: data.payment_type_amount || '',
          'prices.total_discounted': data.payment_type_amount || '',
          policy_total: data.payment_type_amount || '',
          prices: {
            discount_percent: data.discount_percent || '',
            total_discounted: data.payment_type_amount || '',
          },
        })

        this.$axios.$post('/api/notifications/v1/policy-purchased', {
          userName: 'Name missing (API need send it)',
          url: process.env.baseDomainUrl,
          policyType: 'New business',
          paymentMethod: 'GoCardless',
          code: data.policy_code,
          price: data.payment_type_amount,
        })
      }

      this.$router.push({ path: `/dashboard`, query: { type: 'paid' } })
    } catch (error) {
      const { data } = error.response

      console.log('SET_CONVERT_MONTHLY_QUOTE_TO_POLICY_ERROR', error)
      commit('SET_CONVERT_MONTHLY_QUOTE_TO_POLICY_SUCCESS', '')
      commit('SET_CONVERT_MONTHLY_QUOTE_TO_POLICY_ERROR', data || error)

      this.$axios.$post('/api/notifications/v1/policy-purchased-failed', {
        message: data.error,
        code,
        redirectFlowId,
        url: process.env.baseDomainUrl,
        paymentMethod: 'Go Cardless',
      })

      if (data.error === 'Policy is already paid!') {
        console.log('Policy is already paid! Redirect do dashboard')
        this.$toast.success('Policy is already paid! Redirect do dashboard')
        this.$router.push({ path: `/dashboard` })
      } else {
        console.log('TRY AGAIN')
        this.$router.push({ path: `/quote/${code}/summary` })
        this.$toast.error(`Payment failed! Please try again.`, {
          duration: 10000,
        })
      }
    }
    commit('SET_CONVERT_MONTHLY_QUOTE_TO_POLICY_LOADING', false)
  },
}
